/** Hide billing / money UI for users who should not see financial details. */
export const hideFinancialUi = (role) => role === 'foreman';
